/**
 * 파일명: growingTogether.js
 * 작성자: 김준형
 * 작성일자: 26.08.10
 * 설명: About Us - Customers, Partners and RivTechnology / Growing Together
 */
import React from "react";
import useAboutBg from "components/about/aboutAsset";
import style from "css/about.module.css";

function GrowingTogether() {
  const bg = useAboutBg();

  return (
    <section
      className={style.ab_gt}
      style={bg("growing")}
    >
      <div className={style.ab_gt_inner}>
        <div className={style.ab_gt_left}>
          <h2 className={style.ab_gt_title}>
            Customers, Partners
            <br />
            and RivTechnology
          </h2>

          <div className={style.ab_gt_sub_row}>
            <span className={style.ab_gt_line} />
            <strong className={style.ab_gt_sub}>Growing Together</strong>
          </div>
        </div>

        <p className={style.ab_gt_desc}>
          Smart WorkPlace · Telehealth
          <br />
          화상회의 및 통합 관리 시스템 등
          <br />
          비즈니스에 최적화된 다양한 IT 솔루션을 제공하여
          <br />
          고객이 직면한 문제들을 효과적으로 해결하고자 합니다.
        </p>
      </div>
    </section>
  );
}

export default GrowingTogether;
